// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Scalars = require("../../scalars/Scalars.bs.js");
var UTCDate = require("../../reason/common/types/UTCDate.bs.js");
var V4 = require("uuid/v4");
var DateFns = require("date-fns");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Link = require("next/link").default;
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Text__Jsx3 = require("../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ConfirmDialog = require("../../reason/common/ConfirmDialog/ConfirmDialog.bs.js");
var SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var MyBroadcastMessagesWidgetListItem_message_graphql = require("../../__generated__/MyBroadcastMessagesWidgetListItem_message_graphql.bs.js");
var MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql = require("../../__generated__/MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.bs.js");

var convertFragment = MyBroadcastMessagesWidgetListItem_message_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyBroadcastMessagesWidgetListItem_message_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyBroadcastMessagesWidgetListItem_message_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyBroadcastMessagesWidgetListItem_message_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyBroadcastMessagesWidgetListItem_message_graphql.node, convertFragment, fRef);
}

var BroadcastMessageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyBroadcastMessagesWidgetListItem$ConfirmDeleteDialog(props) {
  var onCancel = props.onCancel;
  var onConfirm = props.onConfirm;
  return JsxRuntime.jsx(ConfirmDialog.make, {
              title: "Delete Broadcast Message?",
              ariaLabel: "Confirm Delete Broadcast Message",
              body: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsx(Text__Jsx3.make, {
                            lineHeight: {
                              NAME: "float",
                              VAL: 1.5
                            },
                            children: "Other users can no longer find the message nor start conversations about it. Conversations that you're already in can continue."
                          }),
                      JsxRuntime.jsx("br", {}),
                      JsxRuntime.jsx(Text__Jsx3.make, {
                            fontWeight: "bold",
                            children: "THIS CANNOT BE UNDONE"
                          })
                    ]
                  }),
              isOpen: props.isOpen,
              onCancel: onCancel,
              cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: (function (param) {
                        onCancel();
                      }),
                    children: "No, Keep Message"
                  }),
              confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
                    onClick: (function (param) {
                        onConfirm();
                      }),
                    children: "Yes, Delete Message"
                  })
            });
}

var ConfirmDeleteDialog = {
  make: MyBroadcastMessagesWidgetListItem$ConfirmDeleteDialog
};

function MyBroadcastMessagesWidgetListItem$DeleteBroadcastMessageButton(props) {
  var onDelete = props.onDelete;
  var match = React.useState(function () {
        return false;
      });
  var setIsOpen = match[1];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(MyBroadcastMessagesWidgetListItem$ConfirmDeleteDialog, {
                      isOpen: match[0],
                      onConfirm: (function () {
                          setIsOpen(function (param) {
                                return false;
                              });
                          onDelete();
                        }),
                      onCancel: (function () {
                          setIsOpen(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
                      onClick: (function (param) {
                          setIsOpen(function (param) {
                                return true;
                              });
                        }),
                      disabled: props.disabled,
                      size: "small",
                      children: [
                        JsxRuntime.jsx(Icon__Jsx3.make, {
                              icon: "Trash"
                            }),
                        JsxRuntime.jsx(View__Jsx3.make, {
                              ml: "sm"
                            }),
                        "Delete"
                      ]
                    })
              ]
            });
}

var DeleteBroadcastMessageButton = {
  make: MyBroadcastMessagesWidgetListItem$DeleteBroadcastMessageButton
};

var convertVariables = MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.Internal.convertVariables;

var convertResponse = MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.node, convertResponse, convertWrapRawResponse);

var DeleteBroadcastMessageV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function MyBroadcastMessagesWidgetListItem(props) {
  var listConnectionId = props.listConnectionId;
  var message = use(props.message);
  var match = use$1();
  var deleteBroadcastMessage = match[0];
  var match$1 = SystemMessages.useSystemMessages();
  var addMessage = match$1.addMessage;
  var match$2 = message.category;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs(Link, {
                              href: "/messages/" + message.id,
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: match$2 !== undefined ? match$2.name : "",
                                      className: "text-gray-500 uppercase"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: Core__Option.getOr(message.subject, ""),
                                      className: ""
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("div", {
                              children: Core__Option.getOr(Core__Option.map(message.broadcastAt, (function (s) {
                                          return DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(s)), "MM/dd/yyyy");
                                        })), ""),
                              className: "my-2 md:my-0"
                            })
                      ],
                      className: "col-span-12 lg:col-span-6 flex flex-col md:flex-row md:justify-between md:items-center"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
                              href: "/messages/" + message.id + "/edit",
                              size: "small",
                              children: [
                                JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "Pencil",
                                      size: 15
                                    }),
                                JsxRuntime.jsx(View__Jsx3.make, {
                                      ml: "sm"
                                    }),
                                "Edit"
                              ]
                            }),
                        JsxRuntime.jsx(MyBroadcastMessagesWidgetListItem$DeleteBroadcastMessageButton, {
                              onDelete: (function () {
                                  deleteBroadcastMessage({
                                        connections: Core__Array.keepSome([listConnectionId]),
                                        messageBroadcastId: message.id
                                      }, undefined, undefined, undefined, (function (response, param) {
                                          var match = response.deleteMessageBroadcast;
                                          if (match !== undefined && match.__typename === "MessageBroadcastWasDeleted") {
                                            return addMessage(SystemMessages.Message.make(V4(), "info", "The message was deleted.", 5000, undefined, undefined));
                                          }
                                          addMessage(SystemMessages.Message.make(V4(), "error", "There was a problem deleting your message.", 5000, undefined, undefined));
                                        }), undefined, undefined);
                                }),
                              disabled: match[1]
                            })
                      ],
                      className: "col-span-12 lg:col-span-6 text-right flex flex-row space-x-2 md:justify-end"
                    })
              ],
              className: "grid grid-cols-12 gap-2 py-4 border-t"
            });
}

var make = MyBroadcastMessagesWidgetListItem;

exports.BroadcastMessageFragment = BroadcastMessageFragment;
exports.ConfirmDeleteDialog = ConfirmDeleteDialog;
exports.DeleteBroadcastMessageButton = DeleteBroadcastMessageButton;
exports.DeleteBroadcastMessageV5Mutation = DeleteBroadcastMessageV5Mutation;
exports.make = make;
/* commitMutation Not a pure module */
